class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);

    // View more buttons
    const onViewMore = (event) => {
      event.preventDefault();
      event.stopPropagation();

      const current = event.currentTarget;

      const isExpanded = current.getAttribute("aria-expanded") === "true" ? true : false;
      const filtersList = current.closest(".facets__submenu");
      const filters = filtersList.querySelectorAll(".facets__item");

      filters.forEach((filter) => {
        if (isExpanded && filter.matches(".unhidden")) {
          filter.classList.remove("unhidden");
          filter.classList.add("view-more-hidden");
        } else if (filter.matches(".view-more-hidden")) {
          filter.classList.remove("view-more-hidden");
          filter.classList.add("unhidden");
        }
      })

      current.setAttribute("aria-expanded", !isExpanded );
    };

    // const viewMoreButtons = document.querySelectorAll('.facets__view-more');

    // viewMoreButtons.forEach((button) => {
    //   button.addEventListener('click', onViewMore, true);
    // });

   FacetFiltersForm.setOpenFilterBtnListener();

    // Hide filters button on desktop
    /*
    const hideFilterButton = document.querySelector(".collection-header--filter-sort .js-hide-filters");
    const desktopFilters = document.querySelector(".desktop-facets");

    if (hideFilterButton) {
      hideFilterButton.classList.remove("hidden");
    }

    hideFilterButton.addEventListener("click", ()=>{

      if (hideFilterButton && desktopFilters) {
        const isExpanded = hideFilterButton.getAttribute("aria-expanded") === "true" ? true : false;
        const newExpandedState = isExpanded ? "false" : "true";
        hideFilterButton.setAttribute("aria-expanded", newExpandedState);
        // desktopFilters.classList.toggle('hidden');

        const gridAndFilterContainer = document.querySelector(".product-grid-and-filter");

        if (gridAndFilterContainer) {
          if (newExpandedState === "false") {
            gridAndFilterContainer.style.display = "block";
            gridAndFilterContainer.classList.add("grid-4")
          } else {
            gridAndFilterContainer.style.display = "grid";
            gridAndFilterContainer.classList.remove("grid-4")
          }
        }
      }

      let facets__list_pinned_desktop = document.querySelector('.pinned_filter .facets__inner .facets__list.pinned_desktop');
      if(facets__list_pinned_desktop != null){
        facets__list_pinned_desktop.classList.toggle("remove_padding");
      }

    })
    */

    // Desktop sort by proxy
    // This select just triggers input on the hidden select menu in the filters form
    const sortSelectProxy = document.querySelector(".desktop-sort-proxy");
    if (sortSelectProxy) {
      sortSelectProxy.classList.remove('hidden');
      sortSelectProxy.addEventListener("change", event => {
        const selectInForm = document.querySelector(".desktop-facets .facets__sort select[name='sort_by']");
        const form = selectInForm.closest('form');
        selectInForm.value = event.target.value;
        form.dispatchEvent(new Event('input'));
      })
    }
  }

  // Show/hide toggle for sort and filters on mobile
  // The button in the collection header just triggers a click on the summary element that reveals the filters
  static setOpenFilterBtnListener(){
    const summaryEl = document.querySelector(".facets__open-wrapper");
    const filterButton = document.querySelector(".collection-header--filter-sort .js-show-filters");

    filterButton.removeEventListener("click", this.handleClick);
    this.handleClick = () => {
      summaryEl.click();
    };
    filterButton.addEventListener("click", this.handleClick);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCount');
    document.getElementById('ProductGridContainer')?.querySelector('.collection')?.classList?.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections?.forEach((section) => {
      if (section.section) {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
      } else {
        window.location.reload()
      }
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.setListeners();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.setListeners();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
      //Re-attach eventListener in Filters button after re-rendering
       FacetFiltersForm.setOpenFilterBtnListener();
      updateSelectWidth();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html')?.getElementById('ProductCount')?.innerHTML;
    if (count) {
      const container = document.getElementById('ProductCount');
      container.innerHTML = count;
      container.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll('.facet-filters-form .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = [...html.querySelectorAll(selector)];
      if (activeFacetsElement.length == 0) return;
      const containersSelectors = [...document.querySelectorAll(selector)];
      containersSelectors.map(selector => {
        if(activeFacetsElement[0].innerHTML.trim() == ""){
          return selector.innerHTML = "";
        }
        selector.innerHTML = activeFacetsElement[0].innerHTML;
      });
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.facets__open',
      '.facets__count',
      '.sorting',
      '.facets__clear .facets__total-active-values',
      '.facets__heading .facets__total-active-values',
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelectorAll(selector).forEach((el) => {
        el.innerHTML = html.querySelector(selector).innerHTML
      });
    });

    const drawer = document.querySelector('menu-drawer .facet-filters-form').closest('menu-drawer');
    if (drawer) {
      drawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static renderFilterSearchResults(input) {
    const query = (input.value || '').toLowerCase();
    const submenu = input.closest('.facets__submenu');

    if (!submenu) {
      return;
    }

    submenu.querySelectorAll('label').forEach((label) => {
      // label.classList.remove("hidden");
      const labelText = label.innerText.trim().toLowerCase();
      const listItem = label.closest(".facets__item");

      if (!query) {
        listItem.classList.remove('search-unhidden');
        listItem.classList.remove('search-hidden');
        return;
      }

      if (!labelText.includes(query)) {
        listItem.classList.add('search-hidden');
        listItem.classList.remove('search-unhidden');
      } else {
        listItem.classList.add('search-unhidden');
        listItem.classList.remove('search-hidden');
      }
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid')?.dataset?.id,
      },
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.closest('form');

    // If the checkbox is just a proxy for the "Sort By" select element, trigger input on select
    if (event.target.matches('.facets__sort-proxy')) {
      const checkedInputs = event.target.closest(".facets__submenu").querySelectorAll("input:checked");
      checkedInputs.forEach(input => {
        if (input !== event.target) {
          input.checked = false;
        }
      })


      if (event.target.closest(".facets__submenu").querySelector("input:checked")) {

      }
      const sortSelectMenus = form.querySelectorAll('select.select__select');
      sortSelectMenus.forEach((select, index) => {
        select.value = event.target.value;

        // Dispatch an input event on the form when the final select's value is updated
        if (index === sortSelectMenus.length - 1) {
          form.dispatchEvent(new Event('input'));
        }
      });
      return;
    }

    // If the input is search, hide non-matching filters
    if (event.target.matches("[type='search']")) {
      FacetFiltersForm.renderFilterSearchResults(event.target);
      return;
    }

    const formData = new FormData(form);

    // Exclude some values from the form that we don't need URL params for:
    ["sort_by_proxy"].forEach((item) => formData.delete(item));

    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.setListeners();
customElements.define('facet-filters-form', FacetFiltersForm);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach(element => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        const forms = [...document.querySelectorAll('facet-filters-form')];
        forms.map(form => form.onActiveFilterClick(event));
      });
    });
  }
}

window.updateSelectWidth = () => {
  const sortSelect = document.querySelector('.desktop-sort-proxy');
  const selectedOptionText = sortSelect.options[sortSelect.selectedIndex].text;

  if (selectedOptionText.length > 15) {
    const updatedSelector = document.querySelector('.desktop-sort-proxy');
    updatedSelector.classList.add('long-text');
  } else {
    sortSelect.classList.remove('long-text');
  }
};

window.addEventListener('load', updateSelectWidth);

customElements.define('facet-remove', FacetRemove);